import React from 'react'

import Fees from "./Fees";

import Div from "../layouts/Div";

import Backend from "../../../utils/Backend";
import Notify from "../../../utils/Notify";

import { FEE_INFO_COMPANY_DETAIL } from '../../../constants/Variables';

export default class CompanyFees extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      company: props.company,
      packageObject: null,
      feeErrors: null,
      loading: false
    }

  }

  componentDidMount() {
    Backend.getCompanySubscription(this.state.company).then((companySubscription) => {
      Backend.getPackage(companySubscription.package.id).then((packageObject) => {
        this.setState({companySubscription, packageObject});
      })
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps)
  }

  _handleUpdate(){
    let {
      company,
      packageObject,
      companySubscription
    } = this.state;

    companySubscription.rates = this._removeAssociationKeys(packageObject.rates);
    delete companySubscription.rates.package

    this.setState({loading: true});

    Backend.updateCompanySubscription(company, companySubscription).then((companySubscription) => {
      Notify.success("Fees Updated Successfully.");
      this.setState({loading: false, feeErrors: null});
    }).catch((error) => {
      let errorMessage = error.message;
      Notify.error(errorMessage)
      this.setState({loading: false, feeErrors: error.raw?.rates?.schemes || null});
    })
  }

  _removeAssociationKeys = (obj) => {
    if (Array.isArray(obj)) {
      return obj.map(this._removeAssociationKeys);
    }

    if (obj && typeof obj === "object") {
      return Object.fromEntries(
        Object.entries(obj)
          .filter(([key]) => !key.includes("association"))
          .map(([key, value]) => [key, this._removeAssociationKeys(value)])
      );
    }

    return obj;
  }

  render() {
    let {
      packageObject,
      feeErrors,
      loading,
    } = this.state

    if(!packageObject) return null

    return (
      <Div disabled={loading} showLoadingIndicator={true}>
        <div className="kt-portlet custom-form">
          <div className="kt-portlet__body">
            <Fees
              mode={"company_detail"}
              variation={"company_detail"}
              infoText={FEE_INFO_COMPANY_DETAIL}
              packageObject={packageObject}
              errors={feeErrors}
              rates={packageObject.rates}
              onUpdate={(rates) => {
                packageObject.rates = rates
                this.setState({ packageObject })
              }}
            />
          </div>

          <div className="kt-portlet__foot">
            <div className="kt-form__actions pull-right">
              <button
                type="button"
                className="btn btn-primary ml-3"
                disabled={loading}
                onClick={() => this._handleUpdate()}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </Div>
    )
  }

}
